import { LabelLoader, Loader, LoaderContainer } from "./styles.js";

/**
 * MainLoader component
 *
 * Renders a centered loading spinner and an optional title below it.
 *
 * @param {string} [title] - Optional title text displayed under the spinner.
 * @returns {JSX.Element}
 * @component
 */
export function MainLoader({ title }) {
	return (
		<LoaderContainer>
			<Loader />
			<LabelLoader>{title}</LabelLoader>
		</LoaderContainer>
	);
}
